export const FacilityKey = {
  FACILITY_NAME: 'name',
  FACILITY_TYPE: 'type',
  LEASED: 'isLeased',
  NO_EMP: 'numberOfEmployee',
  FLOOR_SPACE: 'floorSpace',
  ADDRESS: 'address',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
  PINCODE: 'pincode',
  GST: 'taxIdentityNumber',
  BIO_PROTECTED: 'isBiodiversityProtectedArea',
  BIO_ADJACENT_FACILITY: 'isAdjacentToProtectedArea',
  WATER_SCARED: 'isWaterScarceArea',
  SEVERE_IMPACT: 'hasSevereBiodiversityImpact',
  IMPACTED_AREA: 'areaImpacted',
  LESSOR_NAME: 'assetLessorName',
  MOBILE_NO: 'assetLessorMobile',
  RENTED_FROM: 'assetLessorRentedFrom',
  RENTED_TO: 'assetLessorRentedTo',
  rating: 'rating',
  resType: 'restaurantType',
  occupancyRate: 'occupancyRate',
  totalNoOfRooms: 'totalNoOfRooms',
  averageRoomSize: 'averageRoomSize',
  averageMealsPerYear: 'averageMealsPerYear',
  coordinates: 'coordinates',
  ADD_TO_PAST_YEARS: 'addToPastYears',
  PAST_YEAR_FROM: 'pastYearFrom',
  PAST_YEAR_TO: 'pastYearTo'
};
export const FacilityLabel = {
  FACILITY_NAME: 'Facility Name',
  FACILITY_TYPE: 'Facility Type',
  LEASED: 'Is The Facility Leased?',
  NO_EMP: 'Number of Employees',
  FLOOR_SPACE: 'Floor Space',
  ADDRESS: 'Address',
  CITY: 'City',
  STATE: 'State',
  COUNTRY: 'Country',
  PINCODE: 'Pincode',
  GST: 'GST Number',
  BIO_PROTECTED: 'Is The Facility On A Biodiversity Protected Area ?',
  LIST_BIO_PROTECTED: 'Biodiversity Protected Area',
  BIO_ADJACENT_FACILITY:
    'Is The Facility Adjacent To A Biodiversity Protected Area ?',
  WATER_SCARED: 'Is The Facility Located Is Water Scarce Area ?',
  SEVERE_IMPACT: 'Does It Have A Severe Impact On Biodiversity ?',
  IMPACTED_AREA: 'Area Impacted',
  LESSOR_NAME: 'Asset Lessor Name',
  MOBILE_NO: 'Asset Mobile Number',
  RENTED_FROM: 'Rented From',
  RENTED_TO: 'Rented To',
  rating: 'Rating',
  resType: 'Restaurant Type',
  occupancyRate: 'Occupancy Rate',
  totalNoOfRooms: 'Total Number of Rooms',
  averageRoomSize: 'Average Room Size',
  averageMealsPerYear: 'Average Meals',
  ADD_TO_PAST_YEARS: 'Add this facility to the past year/years?',
  PAST_YEAR_FROM: 'Start Year',
  PAST_YEAR_TO: 'End Year'
};

export const FacilityHeadquarterLabel = {
  HEADQUARTER_NAME: 'Headquarter Name',
  HEADQUARTER_ADDRESS: 'Headquarter Address',
  HEADQUARTER_TYPE: 'Headquarter Type',
  LEASED: 'Is the office in a Leased space?'
};

export const colSpan = 6;
